import { ACTION_TYPES as CONVERSATION_ACTION_TYPES } from '../store/modules/conversations.js'
import { Conversations } from '@/api/conversations'
import { MUTATION_TYPES as UI_MUTATION_TYPES } from '@/store/modules/ui'
import UserMixin from '@/util/UserMixin'

export const ConversationsMixin = {
  mixins: [UserMixin],
  data () {
    return {
      unreadCount: 0,
    }
  },
  computed: {
    hasAccessToConversations () {
      if (this.$store.getters.isStaging || this.$store.getters.isCommunityEcosystem) {
        return true
      }

      // Supports legacy ecosystems that still need the "message_dashboard" option enabled
      if (!this.$store.getters.forIntelligenceAndOperations) {
        return this.$store.getters.isFoodleap || this.$store.getters.isAriadne || this.$store.getters.isKlik || this.$store.getters.isS4Fashion
      }

      return this.$store.getters.isEcosystemOperations
    },
  },
  methods: {
    canStartConversation (user) {
      if (!this.isLoggedIn) {
        return false
      }

      if (!this.hasAccessToConversations) {
        return false
      }

      if (user && user.is_deleted) {
        return false
      }

      if (user && user.user_is_deleted) {
        return false
      }

      if (user.id === this.userId) {
        return false
      }

      return this.$store.getters.canActorsBeContacted || this.isOwner
    },
    startConversation (userId) {
      if (!this.isLoggedIn) {
        this.showLoginModal()
        return
      }

      if (userId === this.userId) {
        return
      }

      // actor_id: actorId,
      Conversations.post({ recipient_id: userId }).then((conversation) => {
        this.$store.dispatch(CONVERSATION_ACTION_TYPES.FETCH_CONVERSATIONS_LIST)
        this.$router.push('/profile/conversations/' + conversation.id).then(() => {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, {
            component: 'user-information-side-panel',
            metaData: {
              userId: userId,
              allowDelete: false,
            },
          })
        })
      })
    },
  },
  mounted () {

  },
}
